import { Component, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-plant-handling-instructions-form',
  templateUrl: './plant-handling-instructions-form.component.html'
})
export class PlantHandlingInstructionsFormComponent {
  @Input() options: PlantHandlingOptions;
  @Input() treatment: FormGroup;

  public get plantHandlingInstructions(): FormGroup {
    return <FormGroup>this.treatment.get('plantHandlingInstructions');
  }

  public get lighting(): FormControl {
    return <FormControl>this.plantHandlingInstructions.get('lighting');
  }

  public get temperature(): FormControl {
    return <FormControl>this.plantHandlingInstructions.get('temperature');
  }

  public get humidity(): FormControl {
    return <FormControl>this.plantHandlingInstructions.get('humidity')
  }

  public get imagingNeeded(): FormControl {
    return <FormControl>this.plantHandlingInstructions.get('imagingNeeded');
  }

  public copyValueFrom(copyArgs: PlantHandlingCopyArgs) {
    this.plantHandlingInstructions.patchValue(copyArgs);
    this.plantHandlingInstructions.updateValueAndValidity();
  }
}

export interface PlantHandlingCopyArgs {
  lighting: number;
  temperature: number;
  humidity: number;
  imagingNeeded: boolean;
}

export interface PlantHandlingOptions {
  lightingInstructions: DisplayOption[];
  temperatureInstructions: DisplayOption[];
  humidityInstructions: DisplayOption[];
  pesticideInstructions: PesticideDisplayOption[];
}

export interface DisplayOption {
  id: number;
  display: string;
}

export interface PesticideDisplayOption extends DisplayOption {
  requiresNumberOfDays: boolean;
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/plant-handling-instructions/plant-handling-instructions-form/plant-handling-instructions-form.component.ts